import { type TranslationFunction } from '@unisporkal/localization';
import { getRfSubscriptionLabelKey } from '../../rfSubscriptionLabels';
import {
  PREMIUM_ACCESS_TYPE,
  type BatchAgreement,
  type PremiumAccessAgreementSummary,
} from './types';

const getAgreementLabel = (
  agreement: BatchAgreement,
  t: TranslationFunction,
  userHasMultiplePaAgreements: boolean
): string => {
  const { productType, subFamily, customName } = agreement;
  if (productType === 'RoyaltyFreeSubscription') {
    return t(getRfSubscriptionLabelKey(subFamily));
  }
  const agreementLabelMap: Record<string, string | false> = {
    EditorialSubscription: t('editorial_subscription'),
    EasyAccess: t('easy_access'),
    [PREMIUM_ACCESS_TYPE]: !userHasMultiplePaAgreements
      ? t('premium_access')
      : false,
    ImagePack: t('ultrapack'),
  };
  return agreementLabelMap[productType] || customName;
};

export const getCurrentAgreementRowText = (
  agreement: BatchAgreement,
  t: TranslationFunction,
  userHasMultiplePaAgreements: boolean,
  // Scopes the overage tag to the multi-PA experience —
  // enrichBatchAgreements computes overageReached unconditionally, so
  // without this the tag would also appear with the experience off.
  showOverageTag: boolean
): string => {
  const count = t('count_assets', {
    count: agreement?.authorizedAssets?.length,
  });
  const overageSuffix =
    showOverageTag && agreement.overageReached ? ` ${t('overage_tag')}` : '';
  return `${getAgreementLabel(
    agreement,
    t,
    userHasMultiplePaAgreements
  )}: ${count}${overageSuffix}`;
};

export const getAvailablePaRowText = (
  paAgreement: PremiumAccessAgreementSummary,
  t: TranslationFunction
): string => {
  const label = paAgreement.customName
    ? `${t('premium_access')}: ${paAgreement.customName}`
    : t('premium_access');
  const count = t('count_assets', {
    count: paAgreement.authorizedAssetCount,
  });
  const overageSuffix = paAgreement.isExhausted ? ` ${t('overage_tag')}` : '';
  return `${label}: ${count}${overageSuffix}`;
};
